<template>
  <div>
    <div class="home" v-if="portalConfig.themeLayout.id === 1">
      <SectionChampCinema v-if="portalConfig.text.topPickVideos !== null"/>
      <SectionListings v-if="portalConfig.text.topPickListings !== null"/>
      <SectionResources v-if="portalConfig.text.topPickResources !== null"/>
    </div>
    <div class="home" v-if="portalConfig.themeLayout.id === 2">
      <SectionVideosChampCinema videoEndpoint="/videos/top-picks" v-if="portalConfig.text.topPickVideos !== null" />
      <Pillars :pillarsEndpoint="`/pillars`"/>
    </div>
    <div class="home" v-if="portalConfig.themeLayout.id === 3">
      <SectionVideosChampCinema videoEndpoint="/videos/top-picks" v-if="portalConfig.text.topPickVideos !== null" />
      <SectionResourcesV2 v-if="portalConfig.text.topPickResources !== null"/>
      <Pillars :pillarsEndpoint="`/pillars`"/>
    </div>
  </div>
</template>

<script>
import SectionChampCinema from '@/components/SectionChampCinema'
import SectionVideosChampCinema from '@/components/SectionVideosChampCinema'
import SectionListings from '@/components/SectionListings'
import SectionResources from '@/components/SectionResources'
import SectionResourcesV2 from '@/components/SectionResourcesV2'
import Pillars from '@/components/Pillars'
import { mapGetters } from 'vuex'
export default {
  name: 'Home',
  components: {
    SectionChampCinema,
    SectionListings,
    SectionResources,
    SectionResourcesV2,
    SectionVideosChampCinema,
    Pillars
  },
  computed: {
    ...mapGetters({
      portalConfig: 'getPortalConfig'
    })
  },
  metaInfo () {
    return {
      title: this.portalConfig.portalName + ' - ' + this.portalConfig.text.homePageHeader
    }
  }
}
</script>
